module.exports = __webpack_public_path__ + "img/table.aab36e3c.svg";